<template>
	
  <div class="py-5 px-3 bk-white" id="box-ga">
    <div class="container-fluid">

      <h2 class="text-center mt-lg-5 mb-5">
        General <br v-if="section == 'ab-yachts'" class="d-lg-none">
        Arrangement
      </h2>

      <div class="row text-center">

        <div class="col" v-for="layout in pageItem.layout" :key="layout.id">
          <a :class="['btn-ga', (activeItem == layout.plan) ? 'active' : '']" @click="getItem(layout.plan)">
            {{ layout.title }}
          </a>
        </div>

      </div>
      
			<div id="layout" class="my-4" ref="boxLayout" @click="openFancybox()"></div>

    </div>

    <div v-if="gaPath" class="text-center my-4">
      <a :href="gaPath" target="_blank" class="btn btn-download" @click="launchPdf">
        Download General Arrangement
      </a>
    </div>
  </div>

</template>

<script>
	import { Fancybox } from "@fancyapps/ui";
	import "@fancyapps/ui/dist/fancybox/fancybox.css";
	
  export default {
		name: 'YachtLayouts',
		props: ['section', 'pageItem'],
		data () {
      return {
        activeItem: 'profile',
        alt: 'Profile',
        path: null,
        gaPath: null,
        idPage: null
      }
		},
		computed: {
		},
		methods: {
			getItem(plan) {
				let item = this.pageItem.layout.find((item) => item.plan === plan)
        if (item) {
          this.activeItem = plan
          this.alt = item.title
          this.path = item.src
          this.$refs.boxLayout.style.backgroundImage = "url('"+ this.path +"')"
        }
			},
      openFancybox() {
        Fancybox.show([{
          src: this.path,
          thumb: this.path
        }])
      },
      getGaDoc() {
        if (!this.pageItem.docs) return null
        let docs = this.pageItem.docs
        let that = this
        Object.keys(docs).forEach(function(docType) {
          if (docType === 'arrangements') {
            let item = docs[docType]
            //console.log(item[0].path)
            that.gaPath = item[0].src
            //console.log('GA found', that.gaPath)
            return true
          }
        });
        return null
      },
      launchPdf(ev) {
        this.$store.dispatch('launchPdf', ev)
      },
			calcHeigth() {
        const w = this.$refs.boxLayout.clientWidth
        let h = Math.round(w / 3)
        this.$refs.boxLayout.style.height = h +'px'
				console.log('height: '+ h +'px;')
        this.getItem('profile')
      },
		},
    created() {
      this.idPage = this.pageItem.id
		},
    updated() {
      if (this.idPage !== this.pageItem.id) {
        this.idPage = this.pageItem.id
        this.calcHeigth()
      }
		},
    mounted() {
      this.calcHeigth()
      this.getGaDoc()
    }
	}
</script>

<style scoped>
  .ab-yachts h2 {
    color: var(--color-red);
  }

  #layout {
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
  }

  .btn-ga {
    display: inline-block;
    cursor: pointer;
  }
  .ab-yachts .btn-ga {
    font-family: var(--title-font-family);
    font-size: 14px;
    color: #000;
    text-transform: uppercase;
  }
  .maiora .btn-ga {
    font-family: var(--title-font-family);
    font-size: 20px;
    color: #000;
  }

  .ab-yachts .btn-ga.active {
    border-bottom: 2px solid var(--color-red);
  }

  .maiora .btn-ga.active {
    border-bottom: 2px solid var(--color-blu);
  }

  @media screen and (min-width:992px) {
    .ab-yachts .btn-ga {
      font-size: 20px;
    }
    .maiora .btn-ga {
      font-size: 28px;
    }
  }
</style>
